function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.85938 0.1875L5.85938 2.1875C6.04688 2.39062 6.04688 2.70312 5.85938 2.90625C5.65625 3.09375 5.34375 3.09375 5.14062 2.90625L4 1.75V5.04688C4 5.32812 3.78125 5.54688 3.5 5.54688C3.21875 5.54688 3 5.32812 3 5.04688V1.75L1.85938 2.90625C1.65625 3.09375 1.34375 3.09375 1.14062 2.90625C0.953125 2.70312 0.953125 2.39062 1.14062 2.1875L3.14062 0.1875C3.34375 0 3.65625 0 3.85938 0.1875ZM1 5.54688V6.54688C1 6.82812 1.21875 7.04688 1.5 7.04688H5.5C5.78125 7.04688 6 6.82812 6 6.54688V5.54688C6 5.26562 6.21875 5.04688 6.5 5.04688C6.78125 5.04688 7 5.26562 7 5.54688V6.54688C7 7.375 6.32812 8.04688 5.5 8.04688H1.5C0.671875 8.04688 0 7.375 0 6.54688V5.54688C0 5.26562 0.21875 5.04688 0.5 5.04688C0.78125 5.04688 1 5.26562 1 5.54688Z",
  fill: "#006CA3"
});

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e58d285c.svg";
export { ForwardRef as ReactComponent };